"use client";

import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ChevronDown, ChevronUp } from "lucide-react";

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: "How quickly can I get started with Clairvoyo?",
      answer:
        "You can start using Clairvoyo in as little as 5 minutes. Simply sign up, connect your desired platforms through our secure OAuth integration, and your dashboard will automatically populate with your data. Our Professional and Enterprise users get immediate access to personalized onboarding support to help customize their experience.",
    },
    {
      question: "What platforms can I connect to Clairvoyo?",
      answer:
        "Clairvoyo integrates with major digital platforms including Google Analytics, YouTube, Instagram, LinkedIn, X (Twitter), Whop, Udemy, and Skool. We're constantly adding new integrations based on user needs and feedback. Professional and Enterprise plans include priority access to new platform integrations.",
    },
    {
      question: "How customizable are the dashboards?",
      answer:
        "Very customizable! Essential plans include basic customization with monthly revisions. Professional and Enterprise users get unlimited dashboard customizations, private calls, and access to group chats where you can request changes on demand. You can adjust metrics, create custom views, and organize data exactly how you need it.",
    },
    {
      question: "What kind of support do you offer?",
      answer:
        "Support varies by plan. Essential users get email support with 24-hour response times. Professional users get 24/7 priority support, dedicated success managers, and access to private calls and group chats for immediate assistance. Enterprise users receive all that plus custom training sessions and white-glove integration support.",
    },
    {
      question: "How do you handle data privacy and security?",
      answer:
        "We take data privacy seriously. We only display your data - we never store or use it for any other purpose. You maintain full control and can delete all your data at any time through your account settings. We use secure OAuth for platform connections and never store your platform credentials.",
    },
    {
      question: "Can I try Clairvoyo before committing to a subscription?",
      answer:
        "While we don't offer a free trial, we provide detailed platform demos and consultations to help you understand how Clairvoyo can benefit your business. Our team can walk you through specific use cases and demonstrate how our features align with your needs. Additionally, all plans come with a 30-day satisfaction guarantee.",
    },
  ];

  return (
    <div className="space-y-4 max-w-3xl mx-auto">
      {faqs.map((faq, index) => (
        <Card
          key={index}
          className="border-2 border-gray-100 hover:border-classic-blue/20 transition-all duration-200 cursor-pointer"
          onClick={() => setOpenIndex(openIndex === index ? null : index)}
        >
          <CardHeader className="p-6">
            <CardTitle className="flex justify-between items-center text-xl font-medium">
              {faq.question}
              {openIndex === index ? (
                <ChevronUp className="w-5 h-5 text-classic-blue" />
              ) : (
                <ChevronDown className="w-5 h-5 text-gray-400" />
              )}
            </CardTitle>
          </CardHeader>
          {openIndex === index && (
            <CardContent className="px-6 pb-6 pt-0">
              <p className="text-gray-600">{faq.answer}</p>
            </CardContent>
          )}
        </Card>
      ))}
    </div>
  );
};

export default FAQSection;
